/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Content/view.blocks to change it.
import * as fromFlow from 'Simple/Flow'
import DataVaxiomTxCardFieldDefinitionsCardCreate from 'DesignSystem/Data/DataVaxiom/DataVaxiomTxCardFieldDefinitions/DataVaxiomTxCardFieldDefinitionsCardCreate/index'
import React from 'react'
import TysiaModal from 'DesignSystem/TysiaModal/index'



/** @type {import('Simple/types.js').View} */
export default function Content({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentCard/Content/Content/CreateFieldAction/Content"
  
}) {
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
  return (<React.Fragment
>
<TysiaModal
  viewPath={`${viewPath}/TysiaModal`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
 height="auto"
 width={500}
>
{childProps => (
<DataVaxiomTxCardFieldDefinitionsCardCreate
{...childProps}
  viewPath={`${viewPath}/DataVaxiomTxCardFieldDefinitionsCardCreate`}
 onClose={() => setFlowTo(fromFlow.normalizePath(viewPath, '../No'))}
/>
)}
</TysiaModal>
{children}
</React.Fragment>)
}